import React from "react";
import { Button } from 'react-bootstrap';
import Section from "./section";

const Video = ({ data }) => {

  const {
    field_heading,
    field_subhead,
    field_desc,
    field_youtube_embed,
    field_cta
  } = data
  

  return (
    <Section name='video' heading={field_heading} subhead={field_subhead}>
      {
        !!field_desc &&
        <div className="page__blurb text-left" dangerouslySetInnerHTML={{ __html: field_desc.processed }}></div>
      }
      { 
        !!field_youtube_embed && !!field_youtube_embed.uri &&
        <div className="video">
          <iframe width="100%" height="500" frameBorder="0" src={ field_youtube_embed.uri }>
          </iframe>
        </div>
      }
      {
        !!field_cta &&
        <div className="section__text-cta text-center">
          <Button variant="primary" className="btn-submit" href={ field_cta.uri }>{ field_cta.title }</Button>
        </div>
      }
    </Section>
  )

}

export default Video;